

import { defineComponent, ref, watch } from 'vue';
import vModal from "@/components/vModal.vue";

export default defineComponent({
  name: 'VImportCustomIngredientsModal',
  components: {
    vModal
  },
  props: {
    isOpen: Boolean,
    translations: Object,
    downloadTemplate: String,
  },
  emits: ['cancel', 'submit', 'fileSelected'],
  setup(props, { emit }) {
    const file = ref<File | null>(null);
    const fileInput = ref<HTMLInputElement | null>(null);

    function onCancel() {
      file.value = null;
      emit('cancel');
    }

    function onFileChange(event: Event) {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files[0]) {
        file.value = input.files[0];
        emit('fileSelected', file.value);
      }
    }

    function onSubmit() {
      emit('submit', file.value);
    }

    // Watch for modal open to reset file and input
    watch(() => props.isOpen, (newVal: boolean) => {
      if (newVal) {
        file.value = null;
        if (fileInput.value) {
          fileInput.value.value = '';
        }
      }
    });

    return {
      file,
      fileInput,
      onCancel,
      onFileChange,
      onSubmit,
    };
  },
});
